

const MapIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.00012207" width="48" height="48" rx="4" fill="#17C289" fill-opacity="0.11"></rect>
    <path d="M27.3751 32.0195L20.6251 30.0859V16.5156L27.3751 18.4492V32.0195ZM28.5001 18.3789L32.965 16.5859C33.4923 16.375 34.1251 16.7617 34.1251 17.3594V29.1367C34.1251 29.4883 33.9142 29.8047 33.5626 29.9102L28.5001 31.9492V18.3789ZM14.4025 18.625L19.5001 16.5859V30.1562L15.0001 31.9492C14.4728 32.1602 13.8751 31.7734 13.8751 31.1758V19.3984C13.8751 19.0469 14.0509 18.7305 14.4025 18.625Z" fill="#17C289"></path>
</svg>
  )
}
export default MapIcon
